const erroArrayToString = arrayErros => {
    let errosStr = ''
    let obj = arrayErros
    if (Object.keys(obj).length) {
      Object.keys(obj).forEach(function (item) {
        errosStr += obj[item] + ', '
      })
    }
    return errosStr

}

export { 
  erroArrayToString
}


// WEBPACK FOOTER //
// ./src/utils/trataErroRetornoApi.js